import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { every } from 'lodash-es';
import { find } from 'lodash-es';
import { merge } from 'lodash-es';
import { orderBy } from 'lodash-es';
import { uniq } from 'lodash-es';
import { cloneDeep } from 'lodash-es';
import { remapQuantities, isOutOfStock } from './utils';
import { set } from 'vue';
export var AtcState = /*#__PURE__*/function (AtcState) {
  AtcState[AtcState["ingredients"] = 0] = "ingredients";
  AtcState[AtcState["equipment"] = 1] = "equipment";
  AtcState[AtcState["final"] = 2] = "final";
  return AtcState;
}({});
export default function (_ref) {
  var equipment = _ref.equipment,
    ingredients = _ref.ingredients,
    capacityToCreate = _ref.capacityToCreate,
    ingredientsConfig = _ref.ingredientsConfig,
    quantity = _ref.quantity,
    state = _ref.state,
    slug = _ref.slug,
    id = _ref.id,
    name = _ref.name,
    image = _ref.image,
    parentFamily = _ref.parentFamily;
  var ingredientSkus = computed(function () {
    return Object.keys(quantities.value);
  });
  var extendedIngredients = ref();
  var extendedEquipment = ref();
  watchEffect(function () {
    extendedEquipment.value = equipment.value.map(function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        outOfStock: isOutOfStock(obj),
        isEquipment: true
      });
    });
    extendedIngredients.value = ingredients.value.map(function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        outOfStock: isOutOfStock(obj),
        isEquipment: false
      });
    });
  });
  var hasIngredients = computed(function () {
    return !!extendedIngredients.value.length && !every(extendedIngredients.value, 'outOfStock');
  });
  var hasEquipment = computed(function () {
    return !!extendedEquipment.value.length && !every(extendedEquipment.value, 'outOfStock');
  });
  var quantities = computed(function () {
    var ing = ingredientsConfig.value.reduce(function (a, _ref2) {
      var _ref2$fields = _ref2.fields,
        ingredientSku = _ref2$fields.ingredientSku,
        quantities = _ref2$fields.quantities;
      if (!quantities || !ingredientSku) return a;
      var mappedQuantities = quantities.filter(function (quantity) {
        return quantity.fields != null;
      }).map(function (_ref3) {
        var f = _ref3.fields;
        return f;
      }).map(remapQuantities).filter(function (_ref4) {
        var q = _ref4.quantityToCreate;
        return q;
      });
      return merge(a, _defineProperty({}, ingredientSku, mappedQuantities));
    }, {});
    return ing;
  });
  var products = computed(function () {
    var products = state.value === 'ingredients' ? orderBy(extendedIngredients.value, ['outOfStock'], ['desc']).filter(function (_ref5) {
      var sku = _ref5.sku;
      return ingredientSkus.value.includes(sku);
    }) : orderBy(extendedEquipment.value, ['outOfStock', '_name'], ['desc', 'asc']);
    return products;
  });
  var total = computed(function () {
    var product = products.value[0];
    if (!product) return '';
    var price = cloneDeep(product.price);
    var total = products.value.map(function (_ref6) {
      var _price$value;
      var price = _ref6.price,
        _ref6$quantity = _ref6.quantity,
        quantity = _ref6$quantity === void 0 ? 1 : _ref6$quantity;
      return (price === null || price === void 0 ? void 0 : (_price$value = price.value) === null || _price$value === void 0 ? void 0 : _price$value.centAmount) * quantity;
    }).reduce(function (a, c) {
      return a + c;
    }, 0);
    price.value.centAmount = total;
    return price;
  });
  var availableCapacity = computed(function () {
    var quantitys = uniq(products.value.flatMap(function (_ref7) {
      var _quantities$value$sku;
      var sku = _ref7.sku;
      return (_quantities$value$sku = quantities.value[sku]) === null || _quantities$value$sku === void 0 ? void 0 : _quantities$value$sku.map(function (_ref8) {
        var q = _ref8.quantityToCreate;
        return q;
      });
    }));
    return quantitys.map(function (e) {
      return {
        label: e
      };
    });
  });
  watch(availableCapacity, function () {
    var foundCapacity = find(availableCapacity.value, {
      label: capacityToCreate.value
    });
    selectedCapacity.value = foundCapacity || availableCapacity.value[0] || {};
  });
  var selectedCapacity = ref({});
  var updateQuantity = function updateQuantity() {
    products.value.forEach(function (product) {
      var value = product.baseQuantity * quantity.value;
      set(product, 'quantity', value);
    });
  };
  watch(quantity, updateQuantity);
  watch(selectedCapacity, updateQuantity);
  var setProperPrice = function setProperPrice() {
    products.value.forEach(function (product) {
      var _selectedCapacity$val;
      var quantityConfig = quantities.value[product.sku];
      var quantityToCreate = selectedCapacity === null || selectedCapacity === void 0 ? void 0 : (_selectedCapacity$val = selectedCapacity.value) === null || _selectedCapacity$val === void 0 ? void 0 : _selectedCapacity$val.label;
      var foundConfig = find(quantityConfig, {
        quantityToCreate: quantityToCreate
      });
      var isOos = product.outOfStock;
      var _ref9 = (isOos ? {
          atcQuantity: 0
        } : foundConfig) || {},
        _ref9$atcQuantity = _ref9.atcQuantity,
        atcQuantity = _ref9$atcQuantity === void 0 ? product.isEquipment ? 0 : 1 : _ref9$atcQuantity;
      set(product, 'baseQuantity', atcQuantity);
      set(product, 'quantity', atcQuantity * quantity.value);
    });
  };
  watch(products, setProperPrice, {
    immediate: true
  });
  return {
    products: products,
    availableCapacity: availableCapacity,
    selectedCapacity: selectedCapacity,
    quantity: quantity,
    total: total,
    state: state,
    hasEquipment: hasEquipment,
    hasIngredients: hasIngredients,
    slug: slug,
    id: id,
    name: name,
    image: image,
    parentFamily: parentFamily
  };
}